import React, { useState } from "react";

export default function CourseDescription({ description }) {
  const [expanded, setExpanded] = useState(false);
  const limit = 200;

  const isLong = description.length > limit;
  const displayedText = expanded ? description : description.slice(0, limit);

  return (
    <p className="course-description">
      {displayedText}
      {isLong && !expanded && "... "}
      {isLong && (
        <span
          className="read-more"
          onClick={() => setExpanded(!expanded)}
        >
          {expanded ? " Read Less" : " Read More"}
        </span>
      )}
    </p>
  );
}